// Shared helpers for lead date auto-calculation and the pipeline checklist.
// Used by both Leads.jsx (list + add/edit modal) and LeadDetail.jsx (detail page).

export const addDays = (dateStr, days) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const addMonths = (dateStr, months) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};

export const today = () => new Date().toISOString().slice(0, 10);

// type: "mail"   -> stage only turns green once a mail is actually sent from here
// type: "action" -> a plain, manually-marked milestone (no mail involved)
export const STAGE_DEFS = [
  {
    key: "introMail",
    label: "Send Intro Mail",
    type: "mail",
    subject: (lead) => `Introduction — ${lead?.company || "your company"}`,
    body: (lead) =>
      `Hi ${lead?.contact || "there"},\n\nThanks for connecting — introducing our team and how we can help ${lead?.company || "you"}.\n\nBest,\n`,
  },
  {
    key: "portfolio",
    label: "Send Portfolio",
    type: "mail",
    subject: (lead) => `Our Portfolio — ${lead?.company || "your company"}`,
    body: (lead) =>
      `Hi ${lead?.contact || "there"},\n\nSharing our portfolio for your review.\n\nBest,\n`,
  },
  { key: "meeting", label: "Meeting Done", type: "action" },
  {
    key: "proposal",
    label: "Send Proposal",
    type: "mail",
    subject: (lead) => `Proposal — ${lead?.company || "your company"}`,
    body: (lead) =>
      `Hi ${lead?.contact || "there"},\n\nPlease find our proposal attached.\n\nBest,\n`,
  },
  { key: "negotiation", label: "Negotiation", type: "action" },
];

export const OUTCOME_DEFS = [
  { key: "Won", label: "Won" },
  { key: "Lost", label: "Lost" },
];

export const defaultPipelineStages = () =>
  STAGE_DEFS.reduce((acc, stage) => {
    acc[stage.key] = { done: false, date: "" };
    return acc;
  }, {});